import { render } from "./EatingStatusItem.vue?vue&type=template&id=11d224e1&scoped=true&ts=true"
import script from "./EatingStatusItem.vue?vue&type=script&lang=ts"
export * from "./EatingStatusItem.vue?vue&type=script&lang=ts"

import "./EatingStatusItem.vue?vue&type=style&index=0&id=11d224e1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d224e1"]])

export default __exports__